exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".menu-container {\n  display: inline-block;\n  position: relative; }\n\n.mnu-btn {\n  border: none;\n  background-color: transparent;\n  padding-top: 3px;\n  cursor: pointer; }\n\n.mnu-btn span::before {\n  font-size: 1rem;\n  color: gray; }\n\n.collapsed .menu {\n  display: none; }\n\n.expanded .menu {\n  display: block;\n  position: absolute;\n  z-index: 1;\n  right: -1px;\n  top: -1px; }\n\n.menu-item {\n  height: 40px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  padding-left: 10px;\n  padding-right: 25px;\n  background-color: #fff;\n  white-space: nowrap; }\n\n.menu-item:hover {\n  background-color: #ccc; }\n\n.menu {\n  border: none;\n  overflow: auto;\n  width: -webkit-max-content;\n  width: -moz-max-content;\n  width: max-content;\n  box-shadow: 5px 5px 15px #bebebe; }\n\n.selected_item {\n  background-color: #3E7AFA !important;\n  color: #fff !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/menu-button/menu-button.component.scss
// module id = ../../../../../src/app/core/components/menu-button/menu-button.component.scss
// module chunks = main